import React from "react";

const TermsOfService = () => {
  return (
    <div className="pb-12 lg:pb-100">
      <div className="container">
        <div className="text-center pb-6 lg:py-60">
          <h3 className="title pb-5 tab:pb-30 border-b border-border_sec">
            Terms of Service
          </h3>
        </div>
        <div className="grid gap-8 [&_li]:text-gray [&_ul]:list-disc [&_ul]:ps-7 [&_li]:mb-1">
          <h6 className="text-base">
            Welcome to GuideProAI. By using our services, you agree to these
            Terms of Service ("Terms"). If you do not agree, do not use our
            platform.
          </h6>
          <div className="grid gap-3">
            <p className="font-semibold">1. Acceptance of Terms</p>
            <ul>
              <li>
                By accessing or using our platform, you agree to be bound by
                these Terms and our Privacy Policy.
              </li>
            </ul>
          </div>
          <div className="grid gap-3">
            <p className="font-semibold">2. User Responsibilities</p>
            <ul>
              <li>Use our platform only for lawful purposes.</li>
              <li>Do not share, distribute, or misuse proprietary content.</li>
              <li>Maintain the confidentiality of your login credentials.</li>
            </ul>
          </div>
          <div className="grid gap-3">
            <p className="font-semibold">3. Intellectual Property</p>
            <ul>
              <li>
                All content, trademarks, and software on GuideProAI are owned by
                us or licensed to us. You may not copy, distribute, or create
                derivative works without permission.
              </li>
            </ul>
          </div>
          <div className="grid gap-3">
            <p className="font-semibold">4. Prohibited Activities</p>
            <ul>
              <li>Hacking, scraping, or reverse engineering the platform.</li>
              <li>
                Using the platform to transmit harmful or illegal content.
              </li>
            </ul>
          </div>
          <div className="grid gap-3">
            <p className="font-semibold">5. Limitation of Liability</p>
            <ul>
              <li>
                We are not liable for indirect, incidental, or consequential
                damages arising from your use of the platform.
              </li>
              <li>
                Our liability for direct damages is capped at the amount you
                paid us in the last 12 months.
              </li>
            </ul>
          </div>
          <div className="grid gap-3">
            <p className="font-semibold">6. Subscription and Payment</p>
            <ul>
              <li>Subscriptions renew automatically unless canceled.</li>
              <li>
                No refunds will be issued for partial use of the subscription
                term.
              </li>
            </ul>
          </div>
          <div className="grid gap-3">
            <p className="font-semibold">7. Termination</p>
            <ul>
              <li>
                We may terminate your access for violating these Terms or for
                any reason at our sole discretion.
              </li>
            </ul>
          </div>
          <div className="grid gap-3">
            <p className="font-semibold">8. Governing Law and Jurisdiction</p>
            <ul>
              <li>
                These Terms and any disputes arising from your use of GuideProAI
                shall be governed by the laws of the State of Indiana, without
                regard to its conflict of law principles. You agree that any
                legal action or proceeding related to your use of the platform
                shall be brought exclusively in the state or federal courts
                located in Indiana, and you consent to the personal jurisdiction
                of such courts.
              </li>
            </ul>
          </div>
          <div className="grid gap-3">
            <p className="font-semibold">9. Dispute Resolution</p>
            <ul>
              <li>Disputes will be resolved through arbitration in Indiana.</li>
            </ul>
          </div>
          <div className="grid gap-3">
            <p className="font-semibold">10. Changes to Terms</p>
            <ul>
              <li>
                We reserve the right to modify these Terms. Changes will be
                effective upon posting.
              </li>
            </ul>
          </div>
          <div className="grid gap-3">
            <p className="font-semibold">11. Contact Us</p>
            <ul>
              <li>
                If you have questions, contact us at{" "}
                <a
                  href="mailto:info@guideproai.com"
                  className="text-lan_primary hover:opacity-80 duration-200"
                >
                  info@guideproai.com
                </a>
                .
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TermsOfService;
